import {ModalWrapper} from "reoverlay";
import {useEffect, useState} from "react";
import Button from "../Button";
import Switch from "react-switch";
import {Price} from "../../tools/helpers";
import {Reoverlay} from "reoverlay";
const DivarLadderModal=({price,ladderPrice,onConfirm})=>{
    const [isChecked,setIsChecked]=useState(false);
    const [totalPrice,setTotalPrice]=useState(price.finalPrice);
    const handleClose=()=>{
        setIsChecked(false);
        Reoverlay.hideModal()
    }
    useEffect(() => {
        if(isChecked){
            const newPrice=price.finalPrice+ladderPrice;
            setTotalPrice(newPrice)
        }else {
            setTotalPrice(price.finalPrice)
        }
    }, [isChecked]);
    const handleConfirm=()=>{
        onConfirm(isChecked)
    }
    return  <ModalWrapper  onClose={()=>{}}  animation="slideDown"  contentContainerClassName="w-11/12 flex py-5  flex-col justify-center items-center flex-col md:8/12 lg:w-4/12 xl:w-3/12 rounded-xl">
        <div className="flex justify-center gap-2 items-center px-5 flex-col">
            <h1 className="text-2xl font-bold">تایید نهایی</h1>
            <p className="text-center">در صورت تمایل، می‌توانید گزینه نردبان آگهی را فعال کنید تا آگهی شما در صدر لیست نمایش داده شود.</p>
        </div>
        <div className="grid mt-4  w-full">
        <div className="flex  py-4 border-b bg-gray-100  px-5  justify-between">
                <span>مبلغ</span>
                <span className="font-semibold ">{price?.finalPrice === 0 ? 'رایگان' : Price(price.finalPrice) + ' تومان'}</span>
            </div>
            <div className="flex gap-4 justify-between py-4 border-b   px-5">
                <div className="flex justify-between gap-2  items-center">
                    <span>نردبان کردن آگهی</span>
                    <Switch onColor="#36b570" onChange={setIsChecked} dir="rtl" size={50} checkedIcon={false}
                            uncheckedIcon={false} height={20} width={40} checked={isChecked}/>
                </div>
                <div className={`flex flex-col gap-4 font-semibold justify-end `}>
                    <span className="font-semibold ">{ladderPrice === 0 ? 'رایگان' : Price(ladderPrice) + ' تومان'}</span>
                </div>
            </div>
            <div className="flex bg-gray-100 py-4 px-5 justify-between">
                <span>مبلغ پرداختی</span>
                <span
                    className="text-green-500  font-bold">{totalPrice === 0 ? 'رایگان' : Price(totalPrice) + ' تومان'}</span>
            </div>
        </div>
        <div className="grid w-full mt-5 px-5 pt-5  grid-cols-2 gap-2">
            <Button onClick={handleClose} className="text-sm" rounded="rounded-lg" theme="light">بستن</Button>
            <Button onClick={handleConfirm} className="text-sm" rounded="rounded-lg" theme="green">تایید</Button>
        </div>
    </ModalWrapper>
}
export default DivarLadderModal;